<div class="size-full">
  <main class="bg-background-underground relative h-full overflow-y-hidden" role="main">
    <ng-content />
  </main>
</div>
